export default {
  ON_VIEW_READY: 'onViewReady',
};
